
































import Vue from 'vue';
import Component from 'vue-class-component';
import StatusTracker from '@/components/StatusTracker.vue';
import { mapGetters } from 'vuex';
import { mapModelLike } from '@/store/util';

@Component({
  components: { StatusTracker },
  computed: {
    ...mapModelLike('healthMonitor', [
      'stunDamage',
      'physicalDamage',
    ]),
    ...mapGetters('healthMonitor', [
      'maxPhysicalDamage',
      'maxStunDamage',
      'physicalDamageModifier',
      'stunDamageModifier',
    ]),
  },
})
export default class HealthMonitorBox extends Vue {
  static defaultHeight = 6;
}
